import { FaTimes } from 'react-icons/fa';
import { useTheme } from '../BrandColors/Context/ThemeContext';
import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';

const Modal = ({ isOpen, closeModal, title, children }) => {
  const dealershipTheme = useTheme() || "#3b82f6";
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!isOpen || !mounted) return null;

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in" style={{ zIndex: 999999 }}>
      <div className="glass-panel w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl shadow-2xl border border-blue-200/50 flex flex-col relative scrollbar-hide">
        
        {/* Decorative background element */}
        <div 
          className="absolute top-0 left-0 w-full h-1 opacity-100"
          style={{ backgroundColor: dealershipTheme }}
        />

        <div className="flex items-center justify-between p-6 border-b border-blue-200/50 sticky top-0 bg-white/90 backdrop-blur-md z-10">
          {title && <h2 className="text-xl font-bold text-slate-800 tracking-tight">{title}</h2>}
          <button 
            className="w-8 h-8 rounded-lg flex items-center justify-center text-white transition-all duration-300 hover:ring-4 hover:ring-white/20 hover:shadow-lg hover:brightness-110 ml-auto" 
            onClick={closeModal} 
            style={{background: dealershipTheme}}
          >
            <FaTimes className="w-4 h-4" />
          </button>
        </div>
        
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
